import { useSelector } from 'react-redux'
import {
  selectCustomerSubscriptionData,
  selectMainAddressSubscriptionData,
} from '@/containers/SubscriptionFormPage/SubscriptionFormSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectProviderConfiguration } from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSelectors'
import { E_SIGN_PROVIDER_NAMES } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import { useTranslation } from 'react-i18next'

const useModalContent = () => {
  const { t } = useTranslation()
  const { name: ownerName, lang } = useSelector(selectAuthData)
  const { email, phone1: phone } = useSelector(selectCustomerSubscriptionData)
  const { city } = useSelector(selectMainAddressSubscriptionData)
  const { name: providerName } = useSelector(selectProviderConfiguration)
  const dateLanguage = `${lang}-${lang.toUpperCase()}`
  const date = new Date().toLocaleString(dateLanguage, { timeZone: 'Europe/Paris' })

  const recordingScriptText = E_SIGN_PROVIDER_NAMES.includes(providerName?.toLowerCase())
    ? t('subscriptionForm:header.modal.recording_script_e_sign', { ownerName, providerName, date, email, phone, city })
    : t('subscriptionForm:header.modal.recording_script')

  return {
    recordingScriptText,
  }
}

export default useModalContent
